import { useEffect, useState } from "react";
import { ASK_WAITING_EVENT, AskWaiting, askWaiting, isAskReminderHosted } from "../utils/askReturn";

interface AskWaitingState {
    /** What Ask is waiting on, or null. */
    waiting: AskWaiting | null;
    /** A Save bar on the page shows the reminder. */
    isHosted: boolean;
}

const read = (): AskWaitingState => ({ waiting: askWaiting(), isHosted: isAskReminderHosted() });

/**
 * Whether Ask is minimised with something left to do, for the reminders
 * around the page (the Save bar chip, the header button, search rows).
 */
export const useAskWaiting = (): AskWaitingState => {
    const [state, setState] = useState<AskWaitingState>(read);
    useEffect(() => {
        const handle = () => setState(read());
        handle();
        window.addEventListener(ASK_WAITING_EVENT, handle);
        return () => window.removeEventListener(ASK_WAITING_EVENT, handle);
    }, []);
    return state;
};
